import React, { Fragment } from 'react';

// FontAwesome removed - using MUI icons (commented code sections)

import { Box, Card } from '@mui/material';
//PM count is pmaccounts - billable to pm - commonlinetime
//TotalCommon billable+commonlineitem
//Tenant Total
//Active Account Total


export default function PropertyStats(props) {
  return (
    <Fragment>
      <Box sx={{ display: 'flex', gap: 4 }}>
        <Box sx={{ width: '100%' }}>
          <Card className="card-box mb-4">
            <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
              <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 25%' } }}>
                <div className="divider-v divider-v-lg" />
                <Box sx={{ width: '100%' }}>
                  <div className="text-center py-3">
                    <div>
                      {/* <FontAwesomeIcon
                        icon={['far', 'city']}
                        className="font-size-xxl text-success"
                      /> */}
                    </div>
                    <div className="mt-2 line-height-sm">
                      <b className="font-size-lg">{props.activeAccounts}</b>
                      <span className="text-black-50 d-block">Active Accounts</span>
                    </div>
                  </div>
                </Box>
              </Box>
              <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 25%' } }}>
                <div className="divider-v divider-v-lg" />
                <Box sx={{ width: '100%' }}>
                  <div className="text-center py-3">
                    <div>
                      {/* <FontAwesomeIcon
                        icon={['far', 'house']}
                        className="font-size-xxl text-success"
                      /> */}
                    </div>
                    <div className="mt-2 line-height-sm">
                      <b className="font-size-lg">{props.tenantAccounts}</b>
                      <span className="text-black-50 d-block">Tenants</span>
                    </div>
                  </div>
                </Box>
              </Box>
              <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 25%' } }}>
                <Box sx={{ width: '100%' }}>
                  <div className="text-center py-3">
                    <div>
                      {/* <FontAwesomeIcon
                        icon={['far', 'key']}
                        className="font-size-xxl text-danger"
                      /> */}
                    </div>
                    <div className="mt-2 line-height-sm">
                      <b className="font-size-lg">{props.pmAccounts - props.commonLineItem - props.billableToPm}</b>
                      <span className="text-black-50 d-block">PM</span>
                    </div>
                  </div>
                </Box>
              </Box>
              <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 25%' } }}>
                <Box sx={{ width: '100%' }}>
                  <div className="text-center py-3">
                    <div>
                      {/* <FontAwesomeIcon
                        icon={['far', 'keyboard']}
                        className="font-size-xxl text-danger"
                      /> */}
                    </div>
                    <div className="mt-2 line-height-sm">
                      <b className="font-size-lg">{props.commonAccounts}</b>
                      <span className="text-black-50 d-block">Common</span>
                    </div>
                  </div>
                </Box>
              </Box>
            </Box>
          </Card>
        </Box>
      </Box>
    </Fragment>
  );
}
